import { About as AboutSection } from '../components/About/About';

export function About() {
  return (
    <main>
      <AboutSection />
    </main>
  );
} 